import { createUseStyles } from 'react-jss';

import { variantMapping } from '../../../components/Typography/constants';
import styling from '../../../services/styling';

export default createUseStyles(
  {
    title: {
      textAlign: 'center',
      margin: [0, 'auto', 40],
      maxWidth: styling.sizes.landingSectionMaxWidth,
    },
    helpers: {
      margin: [0, 'auto', 60],
      maxWidth: styling.sizes.landingSectionMaxWidth,
    },
    subtitle: {
      marginBottom: 10,
    },
    body: {
      marginBottom: 46,
      '& p + p': {
        marginTop: 10,
      },
      '& a': {
        ...variantMapping.link.styles,
        fontWeight: 'inherit',
        textDecoration: 'underline',
      },
    },
  },
  { name: 'landingHelp' },
);
